import { Building2, Briefcase, Car, Hammer, HardHat, Leaf, Scissors, Smile, Sparkles, SprayCan, Thermometer, Wrench } from "lucide-react";
import { Reveal, SectionHead } from "./shared";
import { INDUSTRIES } from "../../data/content";

const ICONS = { Building2, Briefcase, Car, Hammer, HardHat, Leaf, Scissors, Smile, Sparkles, SprayCan, Thermometer, Wrench };

export default function Industries() {
    return (
        <section id="industries" className="py-24 sm:py-32" data-testid="industries-section">
            <div className="container-x">
                <SectionHead
                    eyebrow="05 — Industries"
                    title="Built For Businesses That Can't Afford To Miss Leads."
                    sub="Flowtech works with service businesses across the United States — hover any industry to see your AI employee in action."
                    testid="industries-heading"
                />
                <div className="mt-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    {INDUSTRIES.map((ind, i) => {
                        const Icon = ICONS[ind.icon];
                        return (
                            <Reveal key={ind.name} delay={(i % 4) * 0.06}>
                                <div
                                    className="group relative glass card-hover rounded-3xl p-6 h-44 overflow-hidden cursor-default"
                                    data-testid={`industry-card-${ind.name.toLowerCase().replace(/\s+/g, "-")}`}
                                >
                                    <div className="transition-opacity duration-300 group-hover:opacity-0">
                                        <div className="w-11 h-11 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center">
                                            <Icon className="w-5 h-5 text-cyan-300" />
                                        </div>
                                        <h3 className="mt-4 text-base font-bold text-white tracking-tight">{ind.name}</h3>
                                    </div>
                                    <div className="absolute inset-0 p-5 flex flex-col justify-center gap-2.5 opacity-0 translate-y-3 group-hover:opacity-100 group-hover:translate-y-0 transition-[opacity,transform] duration-300 bg-[#0A0F1D]/95">
                                        <p className="text-[11px] text-slate-400 leading-snug">
                                            <span className="ff-mono text-[8px] uppercase tracking-[0.15em] text-slate-500 block mb-1">Lead</span>
                                            “{ind.example[0]}”
                                        </p>
                                        <p className="text-[11px] text-cyan-200 leading-snug">
                                            <span className="ff-mono text-[8px] uppercase tracking-[0.15em] text-cyan-400/80 block mb-1">AI</span>
                                            “{ind.example[1]}”
                                        </p>
                                        <p className="ff-mono text-[8px] uppercase tracking-[0.15em] text-emerald-300 mt-1">
                                            Lead → Conversation → Appointment
                                        </p>
                                    </div>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
